/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomPhoneInput,
  CustomTable,
  FilterBar,
  RowAction,
} from "#components";
import useGet from "#hooks/useGet.js";
import { WebLayout, TableLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { countryCodes, growerTableHeader } from "#utils/seeds.js";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { growerInitialValues } from "#validations/initialValues.js";
import { growerValidationSchema } from "#validations/validationSchema.js";
import usePost from "#hooks/usePost.js";
import useDelete from "#hooks/useDelete.js";
import { useNavigate } from "react-router-dom";
import { WebRoutePath } from "#routes/routePath.jsx";
import ImagesUrl from "#constants/images.js";
import CustomAlert from "../../components/CustomAlert";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import globalConfig from "#constants/globalConfig.js";
import usePut from "#hooks/usePut.js";

export default function GrowerManagement() {
  const navigation = useNavigate();

  const [searchInput, setSearchInput] = useState("");
  const [dataCount, setDataCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [growerDetails, setGrowerDetails] = useState(null);
  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const onOpen = (key, data) => {
    setOpen({ ...open, [key]: true });

    setGrowerDetails(data);
  };

  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setGrowerDetails(null);
    resetForm();
  };

  const {
    data: growerListData,
    isLoading: isGrowerLoading,
    refetch: refetchGrowerList,
  } = useGet(ENDPOINTS.LIST_GROWER, QUERY_KEYS.LIST_GROWER_QUERY_KEY, {
    page: currentPage.toString(),
    limit: dataCount,
    search: searchInput,
  });

  const { mutateAsync: editGrowerMutateAsync, isLoading: isLoadingEditGrower } =
    usePut(ENDPOINTS.EDIT_GROWER, QUERY_KEYS.EDIT_GROWER_QUERY_KEY);

  const { mutateAsync: addGrowerMutateAsync, isLoading: isLoadingAddGrower } =
    usePost(ENDPOINTS.ADD_GROWER, QUERY_KEYS.ADD_GROWER_QUERY_KEY);

  const {
    mutateAsync: deleteGrowerMutateAsync,
    isLoading: isLoadingDeleteGrower,
  } = useDelete(ENDPOINTS.DELETE_GROWER, QUERY_KEYS.DELETE_GROWER_QUERY_KEY);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    setFieldError,
    resetForm,
  } = useFormik({
    initialValues: growerInitialValues,
    validationSchema: growerValidationSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          growerId: growerDetails?._id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          countryCode: values.countryCode,
          phoneNumber: values.phoneNumber,
          location: values.address,
          latitude: "",
          longitude: "",
        };

        if (open.add) {
          try {
            const response = await addGrowerMutateAsync({ data: [data] });
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            refetchGrowerList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await editGrowerMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            refetchGrowerList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    refetchGrowerList();
  };

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };
  const handelViewGrower = (id) => {
    localStorage.setItem(globalConfig.GROWER_ID, JSON.stringify(id));
    navigation(WebRoutePath.GROWER_DETAIL.path);
  };
  const handleDeleteGrower = async (growerId) => {
    CustomAlert({
      title: "Are you sure you want to delete the Grower?",
      confirmButtonText: isLoadingDeleteGrower ? (
        <ClipLoader size={17} color="#fff" />
      ) : (
        "Confirm"
      ),
      icon: "question",
      onConfirm: async () => {
        try {
          const response = await deleteGrowerMutateAsync({
            growerId: growerId,
          });
          AlertTost(response?.message, "success");
          refetchGrowerList();
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  // Pagination functions

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((nextPage) => nextPage + 1);
  };

  //
  const handleExportExlSheet = () => {
    // Create a new workbook
    const ws = XLSX.utils.json_to_sheet(growerListData?.data?.list);

    // Create a new workbook object with the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Export the workbook as an Excel file
    XLSX.writeFile(wb, "ExportedData.xlsx");
  };
  useEffect(() => {
    if (open.edit) {
      setValues({
        countryCode: growerDetails?.countryCode,
        phoneNumber: growerDetails?.phoneNumber,
        email: growerDetails?.email,
        firstName: growerDetails?.firstName?.trimStart(),
        lastName: growerDetails?.lastName?.trimStart(),
        address: growerDetails?.location?.trimStart(),
      });
    }
  }, [open.edit, growerDetails]);
  useEffect(() => {
    refetchGrowerList();
  }, [dataCount, currentPage]);
  useEffect(() => {
    if (searchInput === "") {
      refetchGrowerList();
    }
  }, [searchInput]);

  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <FilterBar
            refetchExterminatorList={refetchGrowerList}
            onSearchButtonClick={onSearchButtonClick}
            onSearchChange={onSearchChange}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            onChange={onDataCountChange}
            rowLimit={dataCount}
          />
          <div className="table_wrapper_card">
            <div className="row gy-3">
              <div className="col-xl-12">
                <div className="sub-heading flex-box">
                  <h2>Grower Listing </h2>

                  <div className="side-content-blk">
                    {/* <div class="form-block p-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="search"
                        placeholder="Search"
                        value={searchInput}
                        onChange={onSearchChange}
                        onKeyPress={(e) => {
                          // e.preventDefault();
                          if (e.key === "Enter") {
                            onSearchButtonClick(e);
                          }
                        }}
                      />
                      <span class="search-icon"></span>
                    </div> */}
                    <div className="side-content-blk">
                      <button
                        className="primary-outline-btn"
                        onClick={() => handleExportExlSheet()}
                      >
                        <span className="outline_btn_icon">
                          <img src={ImagesUrl.exportCSV} alt="calc" />
                        </span>
                        <span className="outline_btn_text">Export CSV</span>
                      </button>
                    </div>
                    <button
                      onClick={() => onOpen("add")}
                      className="primary-btn"
                    >
                      Add New Grower
                    </button>
                  </div>
                </div>

                <TableLayout
                  tableHeader={growerTableHeader}
                  isEmpty={growerListData?.data?.list.length === 0}
                  isLoading={isGrowerLoading}
                  currentPage={currentPage}
                  totalItems={growerListData?.data?.totalItems}
                  onDataCountChange={onDataCountChange}
                  handlePrevPage={handlePrevPage}
                  handleNextPage={handleNextPage}
                  rowLimit={dataCount}
                >
                  <CustomTable tableHeader={growerTableHeader}>
                    {growerListData?.data?.list.map((item, index) => {
                      return (
                        <tr className="cursor-pointer" key={index}>
                          <td
                            onClick={() => handelViewGrower(item._id)}
                          >{`${item?.firstName} ${item?.lastName}`}</td>
                          <td onClick={() => handelViewGrower(item._id)}>
                            {item?.location}
                          </td>
                          <td onClick={() => handelViewGrower(item._id)}>
                            {item?.countryCode && item?.phoneNumber
                              ? `+${item?.countryCode} ${item?.phoneNumber}`
                              : `N/A`}
                          </td>
                          <RowAction
                            activeAction={{
                              edit: false,
                              view: true,
                              delete: false,
                              status: false,
                            }}
                            onEdit={() => onOpen("edit", item)}
                            onDelete={() => handleDeleteGrower(item._id)}
                            onView={() => handelViewGrower(item._id)}
                          />
                        </tr>
                      );
                    })}
                  </CustomTable>
                </TableLayout>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* add new grower modal */}
      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add New Grower" : "Edit Grower"}
        actionButtonTitle={open.add ? "Save" : "Update"}
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={handleSubmit}
        loading={isLoadingAddGrower || isLoadingEditGrower}
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            <div className="col-lg-6">
              <CustomInput
                label="First name"
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                value={values.firstName}
                error={errors.firstName}
                touched={touched.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Last name"
                type="text"
                name="lastName"
                value={values.lastName}
                placeholder="Enter your last name"
                error={errors.lastName}
                touched={touched.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Email Address"
                type="text"
                name="email"
                value={values.email}
                placeholder="Enter your email address"
                error={errors.email}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomPhoneInput
                label="Phone number"
                placeholder={"Enter your phone number"}
                error={errors.phoneNumber}
                touched={touched.phoneNumber}
                countryCode={values.countryCode}
                phoneNumber={values.phoneNumber}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
              />
            </div>

            <div className="col-lg-6">
              <CustomInput
                label="Address"
                type="text"
                placeholder="Enter your address"
                name="address"
                value={values?.address}
                error={errors?.address}
                touched={touched?.address}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </WebLayout>
  );
}
